import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { REQUEST_TYPES } from "shared/config";
import { Check, Form } from "shared/ui";
import "./BasicDetailsForm.styles.css";
import RequestorDetails from "../RequestorDetails/RequestorDetails";

function BasicDetailsForm({
  form,
  formHeader,
  requestType = null,
  handleSubmit,
  validations,
  uploadedFiles = [],
  disabled = false,
  accountsPayableSpecificInfo = null,
  representations = [],
  requestorFullName,
  requestPlacedBy,
  representativeFullName = null,
  toggleAdditionalAcceptorField,
  additionalAcceptance,
  lockAdditionalAcceptance = false,
  displayAdditionalAcceptance = true,
  toggleAdvancePayment,
  advancePayment,
  isSupervisorDisabled = false,
  formControls = null,
  requestStatus = "",
  requestPreviousAction = "",
  selectInternalOrders = null,
  travelAcceptorControls = null,
  disableAdvancePayment = false,
  displayAdvancePayment = false,
  disableCostCenter,
  accomodationOptions = null,
  ocr = null,
  vipRequestor = false,
  advancePaymentCurrencyCode = "",
}) {
  const { t } = useTranslation(["RequestBasicDetails", "Shared"]);
  return (
    <Form form={form} onSubmit={handleSubmit}>
      <fieldset disabled={disabled}>
        <Row className={vipRequestor ? "vip-bg" : ""}>
          <Col md={6} className="mb-3">
            {formHeader}
          </Col>
          <Col>
            <RequestorDetails
              form={form}
              representations={representations}
              requestorFullName={requestorFullName}
              requestPlacedBy={requestPlacedBy}
              requestType={requestType}
            />
            {requestStatus && (
              <h6 className="lh-base">
                {t("labels.request_status")} <br />
                <strong>{requestStatus}</strong>
              </h6>
            )}
          </Col>
          <Col md={requestStatus ? 3 : "auto"}>
            {representativeFullName && (
              <h6 className="mb-4 lh-base">
                {t("labels.representative")} <br />
                <strong>{representativeFullName}</strong>
              </h6>
            )}
            {requestPreviousAction && (
              <h6 className="lh-base">
                {t("labels.previous_action")} <br />
                <strong>{requestPreviousAction}</strong>
              </h6>
            )}
          </Col>
        </Row>
        <hr
          className={`mb-5 mt-4 text-muted ${vipRequestor ? "vip-hr" : ""}`}
        />
        {accountsPayableSpecificInfo}
        <Row className="mt-3">
          {requestType !== REQUEST_TYPES.AMEX_BTA &&
            requestType !== REQUEST_TYPES.CREDIT_CARD && (
              <Form.Input
                label={t("labels.cost_center")}
                name="cost_centre"
                disabled={disableCostCenter}
                displayAs={Col}
              />
            )}

          <Form.Input
            label={t("labels.comment")}
            disabled={
              requestType === REQUEST_TYPES.AMEX_BTA ||
              requestType === REQUEST_TYPES.CREDIT_CARD
            }
            name="comments"
            displayAs={Col}
            as="textarea"
            className="mb-3"
          />
          <Form.Input
            name="supervisor_email"
            type="email"
            label={t("labels.supervisor_email")}
            addon="@"
            disabled={isSupervisorDisabled}
            displayAs={Col}
            md={6}
          />
          <Form.FilesInput
            label={t("labels.attachments")}
            name="attachments"
            disabled={disabled}
            uploadedFiles={uploadedFiles}
            maxSize={validations?.attachments?.max_allowed_file_size_in_bytes}
            max={validations?.attachments?.attachments_count_rules.data?.max}
            min={validations?.attachments?.attachments_count_rules.data?.min}
            acceptedExtensions={
              validations?.attachments?.attachments_allowed_file_types.data
            }
            displayAs={Col}
            md={6}
          />
          <Col md={6} className="mb-3">
            {displayAdditionalAcceptance && (
              <>
                <Check
                  type="switch"
                  id="additional-acceptor-switch"
                  label={t("labels.additional_acceptor")}
                  className="my-2"
                  onChange={toggleAdditionalAcceptorField}
                  checked={additionalAcceptance}
                  disabled={lockAdditionalAcceptance}
                />
                {additionalAcceptance && (
                  <Form.Input
                    name="additional_acceptor_email"
                    type="email"
                    addon="@"
                    disabled={lockAdditionalAcceptance}
                    displayAs={Col}
                    md={12}
                  />
                )}
              </>
            )}
            {displayAdvancePayment && (
              <>
                <Check
                  type="switch"
                  id="advance-payment-switch"
                  label={t("labels.advance-payment-switch")}
                  className="my-2"
                  onChange={toggleAdvancePayment}
                  checked={advancePayment}
                  disabled={disableAdvancePayment || requestStatus !== ""}
                  md={12}
                />
                {advancePayment && (
                  <Form.NumericInput
                    valueIsNumericString={false}
                    addon={advancePaymentCurrencyCode}
                    name="advance_payment"
                    disabled={disableAdvancePayment}
                    decimalScale={2}
                    allowNegative={false}
                    thousandSeparator={" "}
                    displayAs={Col}
                    md={12}
                  />
                )}
              </>
            )}
          </Col>

          <Col>{selectInternalOrders}</Col>
        </Row>
        {ocr}
      </fieldset>
      {accomodationOptions}
      <hr className="my-5 text-muted" />
      {travelAcceptorControls}
      {formControls}
    </Form>
  );
}

export default BasicDetailsForm;
